import { apiAxios } from '@/lib/apiAxios';
const BASE = '/internal/settings';
export const fetchInternalSettings = async () => apiAxios.get(BASE).then((r) => r.data);
export const putInternalSetting = async ({ key, value, }) => apiAxios.put(`${BASE}/${key}`, { value }).then((r) => r.data);
export const sendTelegramTest = async ({ profile, chatId = '', }) => apiAxios
    .post(`${BASE}/telegram/${profile}/test`, { chatId })
    .then((r) => r.data);
export const setupTelegramWebhook = async (profile) => apiAxios
    .post(`${BASE}/telegram/${profile}/setup-webhook`, {})
    .then((r) => r.data);
export const fetchTelegramWebhookInfo = async (profile) => apiAxios.get(`${BASE}/telegram/${profile}/webhook-info`).then((r) => r.data);
